import type { ListTagProps } from "./list-tag.type";
import type { TagProps } from "antd";

import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin, Tag } from "antd";
import { useState } from "react";

import { LIST_PARAMS_PREVIEW_COLOR } from "@/modules/list";

export const ListTag = ({
  icon,
  onClose,
  closeAriaLabel,
  children,
}: ListTagProps) => {
  const [loading, setLoading] = useState(false);

  const onCloseClick: TagProps["onClose"] = (e) => {
    e.preventDefault();
    setLoading(true);
    onClose?.(e);
  };

  return (
    <Spin spinning={loading} indicator={<LoadingOutlined spin />} size="small">
      <Tag
        variant="outlined"
        color={LIST_PARAMS_PREVIEW_COLOR}
        icon={icon}
        onClose={onCloseClick}
        closeIcon={<CloseOutlined aria-label={closeAriaLabel} />}
      >
        {children}
      </Tag>
    </Spin>
  );
};
